// Ant Design
import { Layout } from 'antd';
import { useSelector } from 'react-redux';

// project import
import { drawerWidth } from '@/config';
import { getSidebarColor } from '@/themes/antd-theme';
import { useTheme } from '@/App';

const { Sider } = Layout;

// Collapsed width constant
export const collapsedWidth = 80;

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = ({ open, children, ...other }) => {
  const { theme_color } = useSelector((state) => state.company_profile);
  const { isDark } = useTheme();

  // Get sidebar color based on dark/light mode
  const bgColor = getSidebarColor(theme_color, isDark);
  const width = open ? drawerWidth : collapsedWidth;

  return (
    <Sider
      {...other}
      width={width}
      collapsed={!open}
      collapsedWidth={collapsedWidth}
      trigger={null}
      className="transition-all duration-300 ease-in-out overflow-visible"
      style={{
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        borderRight: open ? '1px solid rgba(255, 255, 255, 0.12)' : 'none',
        boxShadow: !open ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none',
        overflow: 'visible',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 1001,
        height: '100vh',
        minHeight: '100vh',
        backgroundColor: bgColor,
      }}
    >
      {children}
    </Sider>
  );
};

export default MiniDrawerStyled;
